import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/677cc2a1-65f8-4f88-8939-e2d340fcad6e";
export const REGISTER_URL = "https://a.ntrk2.com/be9e607a-07c8-4d60-ac07-cd8dec722218";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://me678.kzw2a.com/download?openExternalBrowser=1&id=fw5d4d4yox5shg8";

export * from "./codes";
export * from "./context";
